"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.claimRecordAddress = exports.treasuryTokenAuthorityAddress = exports.findTreasuries = exports.findClaimRecords = exports.treasury = exports.getMultipleClaimRecords = exports.getClaimableAmount = exports.claimRecordNullable = exports.claimRecord = void 0;
const web3_js_1 = require("@solana/web3.js");
const sdk_1 = require("./sdk");
const ts_common_1 = require("@marinade.finance/ts-common");
async function claimRecord({ program, address, authority, treasury = sdk_1.STAKERS_TREASURY, }) {
    const claimRecordPubkey = takeClaimRecordAddress({
        program,
        address,
        authority,
        treasury,
    });
    return program.account.claimRecord.fetch(claimRecordPubkey);
}
exports.claimRecord = claimRecord;
async function claimRecordNullable({ program, address, authority, treasury = sdk_1.STAKERS_TREASURY, }) {
    const claimRecordPubkey = takeClaimRecordAddress({
        program,
        address,
        authority,
        treasury,
    });
    return program.account.claimRecord.fetchNullable(claimRecordPubkey);
}
exports.claimRecordNullable = claimRecordNullable;
async function getClaimableAmount({ program, address, authority, treasury = sdk_1.STAKERS_TREASURY, }) {
    const claimRecordPubkey = takeClaimRecordAddress({
        program,
        address,
        authority,
        treasury,
    });
    const claimRecordData = await claimRecord({
        program,
        address: claimRecordPubkey,
    });
    return claimRecordData.nonClaimedAmount;
}
exports.getClaimableAmount = getClaimableAmount;
function takeClaimRecordAddress({ program, address, authority, treasury, }) {
    if (address !== undefined) {
        return address;
    }
    else if (authority !== undefined && treasury !== undefined) {
        return claimRecordAddress({
            authority,
            treasury,
            programId: program.programId,
        }).address;
    }
    else {
        throw new Error('takeClaimRecordAddress: address or authority and treasury must be provided');
    }
}
async function getMultipleClaimRecords({ program, addresses, }) {
    const result = [];
    // getMultipleAccounts should limit by 100 of addresses, see RPC doc
    for (const addressesChunked of (0, ts_common_1.chunkArray)(addresses, 100)) {
        const fetchedRecords = await program.account.claimRecord.fetchMultiple(addressesChunked);
        for (const [index, fetchedRecord] of fetchedRecords.entries()) {
            result.push({
                publicKey: addressesChunked[index],
                account: fetchedRecord,
            });
        }
    }
    return result;
}
exports.getMultipleClaimRecords = getMultipleClaimRecords;
async function treasury({ program, address, }) {
    return program.account.treasury.fetch(address);
}
exports.treasury = treasury;
async function findClaimRecords({ program, treasury, authority, }) {
    if (treasury && authority) {
        const { address } = claimRecordAddress({
            programId: program.programId,
            treasury,
            authority,
        });
        const claimRecordData = await claimRecordNullable({ program, address });
        if (claimRecordData === null) {
            return [];
        }
        else {
            return [{ publicKey: address, account: claimRecordData }];
        }
    }
    else {
        const filters = [];
        if (treasury) {
            filters.push({
                memcmp: {
                    bytes: treasury.toBase58(),
                    offset: 8, // 8 anchor offset
                },
            });
        }
        if (authority) {
            filters.push({
                memcmp: {
                    bytes: authority.toBase58(),
                    offset: 40, // 8 anchor offset + 32 treasury pubkey
                },
            });
        }
        return await program.account.claimRecord.all(filters);
    }
}
exports.findClaimRecords = findClaimRecords;
async function findTreasuries({ program, adminAuthority, }) {
    const filters = [];
    if (adminAuthority) {
        filters.push({
            memcmp: {
                bytes: adminAuthority.toBase58(),
                offset: 8, // 8 anchor offset
            },
        });
    }
    return await program.account.treasury.all(filters);
}
exports.findTreasuries = findTreasuries;
function treasuryTokenAuthorityAddress({ programId = new web3_js_1.PublicKey(sdk_1.INCENTIVES_DISTRIBUTION_PROGRAM_ID), treasury, }) {
    const [address, bump] = web3_js_1.PublicKey.findProgramAddressSync([sdk_1.TREASURY_TOKEN_AUTHORITY_SEED, treasury.toBuffer()], programId);
    return { address, bump };
}
exports.treasuryTokenAuthorityAddress = treasuryTokenAuthorityAddress;
function claimRecordAddress({ programId = new web3_js_1.PublicKey(sdk_1.INCENTIVES_DISTRIBUTION_PROGRAM_ID), treasury, authority, }) {
    const [address, bump] = web3_js_1.PublicKey.findProgramAddressSync([sdk_1.CLAIM_RECORD_ACCOUNT_SEED, treasury.toBuffer(), authority.toBuffer()], programId);
    return { address, bump };
}
exports.claimRecordAddress = claimRecordAddress;
//# sourceMappingURL=api.js.map